import defaultSiteContent from "../data/site-content.json";

const delay = (ms = 50) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchSiteContent = async (key) => {
  await delay();
  const localVal = localStorage.getItem(`site_content_${key}`);
  if (localVal) {
    try {
      return JSON.parse(localVal);
    } catch (e) {
      // fallback
    }
  }
  
  if (defaultSiteContent && defaultSiteContent[key]) {
    return { value: defaultSiteContent[key] };
  }
  
  throw new Error(`Site content for key "${key}" not found.`);
};

export const fetchAdminSiteContent = async (adminKey) => {
  await delay();
  return fetchSiteContent("home");
};

export const saveAdminSiteContent = async (adminKey, key, value) => {
  await delay();
  localStorage.setItem(`site_content_${key}`, JSON.stringify({ value }));
  return { success: true, value };
};
